import { replaceSpaceWithHyphen } from '../../Utils/CommonUtils';
import { IPRODUCTS } from './types';

export const getShortDate = (value: string): string => {
  const date = new Date(value);
  const formatDate = date.toLocaleDateString('default', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return formatDate;
};

export const getProductIdByName = (
  productName: string,
  productList: IPRODUCTS[]
): string => {
  const isProductNameAnId = isNaN(Number(productName)) ? false : true;
  if (isProductNameAnId) return productName;

  const matchingProduct = productList.filter((item) => {
    return (
      replaceSpaceWithHyphen(item.title.toLowerCase()) ===
      replaceSpaceWithHyphen(productName.toLowerCase())
    );
  });

  return matchingProduct.length ? `${matchingProduct[0]?.id}` : '';
};

export const isItrProduct = ({ name = '', id = '' }): boolean =>
  name?.toLowerCase() === 'itr' || id === '4';
